import React from 'react'
import {Link} from 'react-router-dom'
import Initials from '../../../../components/Initials'
import Date from '../../../../components/Date/Date'
import {getBadgeColor} from '../../../../utils/badge'
import OrderAuditTableActionsMenu from '../action-menus/OrderAuditTableActionsMenu'

const OrderAuditTableRow = ({row, hasWritePermission, actionOverlay, tabView}: any) => {
  return (
    <tr>
      <td>
        <Date date={row.date} isDynamicFormat={false} />
      </td>
      <td>
        <Link
          to={`/orders/all-orders/summary?id=${row.order_id}`}
          className='text-dark text-decoration-underline text-hover-primary'
          target='_blank'
        >
          #{row.order_id}
        </Link>
      </td>
      <td>
        <Link
          to={`/customers/details/${row.customer.id}`}
          state={{
            id: row.customer.id,
          }}
          target='_blank'
          className='d-flex align-items-center flex-grow-1 text-start cursor-pointer text-dark'
        >
          <div className='symbol symbol-circle symbol-35px me-3'>
            <Initials text={row.customer.name[0]} />
          </div>
          <div className='d-flex flex-column'>
            <Link
              to={`/customers/details/${row.customer.id}`}
              className='text-dark fw-semibold text-hover-primary'
              target='_blank'
            >
              {row.customer.name}
            </Link>
            <span className='align-items-center text-muted'>{row.customer.email}</span>
          </div>
        </Link>
      </td>
      <td>
        <div className='d-flex align-items-center flex-grow-1 text-start cursor-pointer text-dark'>
          <div className='symbol symbol-circle symbol-35px me-3'>
            <Initials text={row.representative.name[0]} />
          </div>
          <div className='d-flex flex-column'>
            <span className='text-dark fw-semibold'>{row.representative.name}</span>
            <span className='align-items-center text-muted'>{row.representative.email}</span>
          </div>
        </div>
      </td>
      <td>
        <span className={`badge ${getBadgeColor(row.status, 'light')} badge-lg`}>
          <div className='align-items-center'>{row.status}</div>
        </span>
      </td>
      <td>{row.total}</td>
      <td>{row.last_updated_by}</td>
      <td>
        <Date date={row.last_updated_date} isDynamicFormat={false} />
      </td>
      <td className={`${tabView === 'archived' ? '' : 'd-none'}`}>{row.archived_by}</td>
      <td className={`${tabView === 'archived' ? '' : 'd-none'}`}>{row.note}</td>
      {hasWritePermission && actionOverlay(OrderAuditTableActionsMenu)}
    </tr>
  )
}

export default OrderAuditTableRow
